<template>
    <div class="clearfix rounded mt-4 pb-5 mx-auto">

        <l-a-compensatory-leaves-list-applied v-on:updateList="reloadList"
            ref="appliedList"></l-a-compensatory-leaves-list-applied>


        <l-a-compensatory-leaves-list-approved v-on:updateList="reloadList"
            ref="approvedList"></l-a-compensatory-leaves-list-approved>


        <l-a-compensatory-leaves-list-declined v-on:updateList="reloadList"
            ref="declinedList"></l-a-compensatory-leaves-list-declined>

    </div>
</template>

<script>
export default {

    mounted() {
        if (this.check_ce == 1) {
            if (this.ce_flg == 1)
                this.ce = true;
            else
                this.ce = false;

        }
    },
    data() {
        return {
            test_var: 1,
        }
    },
    methods: {
        reloadList: function (data) {
            // Refresh List Data
            if (data.status == 0) {
                if (this.$refs.appliedList && this.$refs.appliedList.getLeaves) {
                    this.$refs.appliedList.getLeaves();
                }
            }
            if (data.status == 1) {
                if (this.$refs.approvedList && this.$refs.approvedList.getLeaves) {
                    this.$refs.approvedList.getLeaves();
                }
            }
            if (data.status == 2) {
                if (this.$refs.declinedList && this.$refs.declinedList.getLeaves) {
                    this.$refs.declinedList.getLeaves();
                }
            }
        }
    },
    created: function () {
    },
    computed:
    {
    }
}
</script>
<style scoped>
.img-holder {
    cursor: not-allowed;
    pointer-events: none;
}
</style>